import { Fragment } from "react";

/** "Was Paare *über uns* schreiben": the starred part becomes the italic wine accent. */
export function Fancy({ text, accent = "font-normal italic text-danish-700" }: { text: string; accent?: string }) {
  return (
    <>
      {text.split("*").map((part, i) =>
        i % 2 ? (
          <span key={i} className={accent}>
            {part}
          </span>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}

/** "Euer Fall *könnte der nächste sein.*" → ["Euer Fall", "könnte der nächste sein."], for the site's title + accent props. */
export function splitAccent(text: string): [string, string | undefined] {
  const [plain, accent] = text.split("*");
  return [plain.trim(), accent?.trim() || undefined];
}
